import { Layer } from 'react-map-gl/mapbox'

import type { FC } from 'react'

interface StyledMapLabelLayerProps {
	beforeId?: string
	id: string
	'source-layer': string
}

export const StyledMapLabelLayer: FC<StyledMapLabelLayerProps> = (props) => {
	return (
		<Layer
			{...props}
			type="symbol"
			layout={{
				'text-field': ['get', 'NAME'],
				'text-size': 12,
				'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
				'text-transform': 'uppercase',
			}}
			paint={{
				'text-color': '#3A2E2F',
				'text-opacity': [
					'step',
					['zoom'],
					0, // Fully transparent below zoom level 8
					8,
					1, // Fully opaque at zoom level 8 and above
				],
				'text-halo-color': 'rgba(255,255,255,0.8)',
				'text-halo-width': 2,
				'text-halo-blur': 1,
			}}
		/>
	)
}
